module.exports = __webpack_public_path__ + "img/fjjt2.b040150b.png";